
import { defineComponent } from 'vue';
import { useGalleryStore } from '@/store/GalleriesStore';
import { usePrivateSellersStore } from '@/store/PrivateSellersStore';
import { useAuthStore } from '@/store/AuthStore';
import Swal from 'sweetalert2';

export default defineComponent({
  props: {
    show: Boolean,
    artwork: {
      type: Object,
      default: null,
    },
  },
  data() {
    const galleryStore = useGalleryStore();
    const privateSellerStore = usePrivateSellersStore();
    const authStore = useAuthStore();
    return {
      galleryStore,
      privateSellerStore,
      authStore,
      images: [] as any[],
      isLoading: false,
    };
  },
  computed: {
    currentStore() {
      return this.authStore.userRole === 'gallery'
        ? this.galleryStore
        : this.privateSellerStore;
    },
  },
  name: 'App',
  methods: {
    async getImages() {
      const data = {
        object_id: this.artwork.id,
        object_type: 'Artwork',
      };
      const res = await this.currentStore.getAttachments(data);
      this.images = res.data.items;
    },
    onFilesSelected(event: any) {
      const selectedFiles = event.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        const imageUrl = URL.createObjectURL(file);
        this.images.push({
          id: Date.now() + i,
          original: imageUrl,
          file: file,
          isNew: true,
        });
      }
    },
    async deleteImage(id: number, index: number) {
      const selectedImage = this.images[index];

      if (selectedImage.isNew) {
        this.images.splice(index, 1);
        return;
      }
      try {
        const data = {
          object_type: 'Artwork',
          object_id: this.artwork.id,
        };
        const response = await this.currentStore.deleteAttachment(id, data);
      } catch (err) {
        console.log(err);
      }
      this.images.splice(index, 1);
    },

    async uploadImages() {
      this.isLoading = true;
      let successfulUploads = 0;
      const newImages = this.images.filter((image) => image.isNew);

      for (const image of newImages) {
        const formData = new FormData();
        formData.append('object_type', 'Artwork');
        formData.append('object_id', this.artwork.id);
        if (image.file) {
          formData.append('image', image.file, image.file.name);
        } else {
          continue;
        }

        try {
          const response = await this.currentStore.addAttachment(formData);

          if (response.success) {
            successfulUploads++;
          } else {
            console.error(`Error uploading image ID: ${image.id}`);
          }
        } catch (error) {
          console.error('There was an error uploading the image:', error);
        }
      }

      if (successfulUploads === newImages.length) {
        Swal.fire('Success', 'All new images uploaded successfully', 'success');
        newImages.forEach((img) => (img.isNew = false));
        this.$emit('close');
      } else {
        Swal.fire(
          'Error',
          `${successfulUploads} out of ${newImages.length} images uploaded successfully. Check console for errors.`,
          'error'
        );
      }
      this.isLoading = false;
    },
    cancel() {
      this.$emit('close');
    },
  },
  async created() {
    await this.getImages();
  },
});
